import React, { useRef, useState } from 'react';
import { Col, Card, Placeholder, Tooltip, Overlay } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { formatAmount } from 'utils';

interface PropsType {
  isMain: boolean;
  heading: any;
  amount: any;
  styles?: any;
  backgroundColor?: string;
  backgroundImage?: string;
  quantity?: string;
  additionalData?: string;
  addClassName?: string;
  earmarkedBalance?: any;
  metalCode?: string;
  redirectLink?: string;
}

const IndicatorCard: React.FC<PropsType> = ({
  isMain,
  heading,
  amount,
  styles,
  backgroundColor,
  backgroundImage,
  quantity,
  addClassName,
  additionalData,
  earmarkedBalance,
  metalCode = null,
  redirectLink = null,
}) => {
  const history = useHistory();
  const [isShow, setIsShow] = useState(false);
  const target = useRef(null);

  const formatQuantity = (quantity) => {
    if (Number(quantity) && Number(quantity) > 1000) {
      const shortQuantity = (Number(quantity) / 1000).toFixed(2);
      return (
        <>
          <div
            ref={target}
            onMouseEnter={() => setIsShow(true)}
            onMouseLeave={() => setIsShow(false)}
            style={{ width: 'fit-content' }}
          >
            {`${shortQuantity} kg`}
          </div>

          <Overlay target={target.current} show={isShow} placement='bottom'>
            {(props) => (
              <Tooltip id='overlay-example' {...props}>
                {`${quantity} g`}
              </Tooltip>
            )}
          </Overlay>
        </>
      );
    } else {
      return `${quantity} g`;
    }
  };

  return (
    <>
      {isMain ? (
        <Card
          className={`base-card ${addClassName}`}
          style={{
            backgroundColor: backgroundColor || '',
            backgroundImage: backgroundImage ? `url(${backgroundImage})` : '',
            backgroundPosition: 'left center',
            backgroundSize: 'cover',
            ...styles,
          }}
        >
          <Card.Body>
            <div>
              <Card.Title>
                {heading ? (
                  heading
                ) : (
                  <Placeholder as={Card.Title} animation='glow'>
                    <Placeholder lg={12} />
                  </Placeholder>
                )}
              </Card.Title>

              {!amount || amount == '₹ undefined' ? (
                <Placeholder as={Card.Title} animation='glow'>
                  <Placeholder lg={12} />
                </Placeholder>
              ) : (
                <h1>{amount}</h1>
              )}

              <p className="mb-0 text-muted earmarked-text small">
                {earmarkedBalance && earmarkedBalance != '₹ undefined'
                  ? `Earmarked Balance ${earmarkedBalance}`
                  : ''}
              </p>
            </div>
          </Card.Body>
        </Card>
      ) : (
        <Card
          className={`base-card ${addClassName}`}
          style={{
            backgroundImage: backgroundImage ? `url(${backgroundImage})` : '',
            backgroundPosition: 'top center',
            backgroundSize: 'cover',
            cursor: redirectLink ? 'pointer' : 'default',
          }}
          onClick={() => {
            if (metalCode && redirectLink) history.push(redirectLink);
          }}
        >
          <Card.Body>
            <div className='align-items-end w-100 d-flex'>
              <Col className='col-6'>
                <Card.Title>
                  {heading ? (
                    heading
                  ) : (
                    <Placeholder as={Card.Title} animation='glow'>
                      <Placeholder xs={4} />
                    </Placeholder>
                  )}
                </Card.Title>
                <h1>
                  {quantity ? (
                    formatQuantity(quantity)
                  ) : (
                    <Placeholder as={Card.Title} animation='glow'>
                      <Placeholder lg={8} />
                    </Placeholder>
                  )}
                </h1>
              </Col>
              <Col className='col-6'>
                {additionalData && <Card.Title>{additionalData}</Card.Title>}
                <div>
                  {!amount || amount == '₹ undefined' ? (
                    <Placeholder as={Card.Title} animation='glow'>
                      <Placeholder lg={8} />
                    </Placeholder>
                  ) : (
                    <h1>{amount}</h1>
                  )}
                  {earmarkedBalance && (
                    <h6 className="text-start text-muted earmarked-text m-0 mt-2 small">
                      Earmarked Balance <br />
                      {formatAmount(earmarkedBalance, 4)}g
                    </h6>
                  )}
                </div>
              </Col>
            </div>
          </Card.Body>
        </Card>
      )}
    </>
  );

  /* return (
        <Grid item xs={6} md={6}>
            {
                isMain ? (
                    <Card variant="outlined" sx={{
                        bgcolor: backgroundColor ? backgroundColor : '',
                        backgroundImage: backgroundImage ? `url(${backgroundImage})` : '',
                        backgroundPosition: 'top center',
                        backgroundSize: "cover"

                    }} >
                        <CardContent sx={{ px: 10, pt: 3, pb: 8, ...styles }}>
                            <Typography variant="h5" component="div">
                                {heading}
                            </Typography>

                            <Typography
                                variant="h3"
                                style={{
                                    fontWeight: 600,
                                    color: styles.color
                                }}
                            >
                                {amount}
                            </Typography>
                        </CardContent>
                    </Card>
                ) : (
                    <Card variant="outlined" sx={{
                        backgroundImage: backgroundImage ? `url(${backgroundImage})` : '',
                        backgroundPosition: 'top center',
                        backgroundSize: "cover"
                    }}>
                        <CardContent sx={{ px: 10, pt: 3, pb: 8, color: styles.color }}>
                            <Grid container spacing={2} sx={{alignItems: 'end'}}>
                                <Grid item xs={6} md={6}>
                                    <Typography variant="h5" component="div">
                                        {heading}
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        style={{
                                            fontWeight: 600,
                                        }}
                                    >
                                        {quantity}
                                    </Typography>
                                </Grid>
                                <Grid item xs={6} md={6}>
                                    <Typography
                                        variant="h4"
                                        style={{
                                            fontWeight: 600,
                                        }}
                                    >
                                        {amount}
                                    </Typography>
                                </Grid>
                            </Grid>
                            {/!*<Typography variant="h5" component="div">
                                Total Holdings
                            </Typography>

                            <Typography
                                variant="h4"
                                style={{
                                    fontWeight: 600,
                                }}
                            >
                                470,000,00
                            </Typography>*!/}
                        </CardContent>
                    </Card>
                )
            }
        </Grid>

    ) */
};
export default IndicatorCard;
